export default __webpack_public_path__ + "static/mobile_KV17-9a5301a6d565f3c821a1e813d9d007af.mp4";